export const get_security_transfer = `query get_security_transfer($id: String!){
    get_security_transfer(id: $id){
        transaction_code
        status
        account
        to_provider
        security{
            short_name
            name
            stock_market_locality
            currency{
                currency
                name
                decimal
            }
        }
        amount
        order_date
        fulfillment_date
    }
}`;
